export const aciHalfBoard = {
    iconName: 'half-board',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M7.179 9.643V22.5M5.75 2.5v5.715a1.429 1.429 0 002.857 0V2.5',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M17.893 3.214v18.572M11.465 8.214c.51-.476 2.081-1.428 4.285-1.428M11.465 18.214c.51.476 2.081 1.429 4.285 1.429',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                },
            },
        ],
    },
};
